<template>
  <div class="box">
      <adagent></adagent>
      <adenterprise></adenterprise>
  </div>
</template>

<script>
import adagent from '../components/adagent.vue'
import Adenterprise from '../components/adenterprise.vue'
export default {
    components: { adagent, Adenterprise },

}
</script>

<style lang="scss" scoped>
    .box{
        margin-top: 7.5px;
    }
</style>